<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <l-map
      ref="map"
      class="map"
      :center="center"
      :options="{ zoomControl: false, attributionControl: false }"
      :zoom="zoom"
      @click="onMapClick"
    >
      <div style="padding-bottom: 20px">
        <l-control-zoom
          position="topleft"
          zoom-in-text="<i style='color: black;'>+</i>"
          zoom-out-text="<i style='color: black;'>-</i>"
        >
        </l-control-zoom>
      </div>
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <vue2-leaflet-marker-cluster
        :options="optionsMarkerCluster"
        @clusterclick="onClusterClick"
      >
        <div v-for="(item, index) in filteredDoorphones" :key="index">
          <l-marker :lat-lng="[item.geo_lat, item.geo_lon]" :draggable="false">
            <marker-cluster-map
              :item="item"
              :lastUserMarker="lastUserMarker">
            </marker-cluster-map>
          </l-marker>
        </div>
      </vue2-leaflet-marker-cluster>
      <l-polygon
        v-if="colorSelected"
        :lat-lngs="currentPolygon"
        :options="currentPolygonOptions" />
      <div v-for="item in resTerritory" :key="'polygon-' + item.id">
        <l-polygon
          v-if="!polygonStatesshowPopup"
          :lat-lngs="item.area"
          :options="{
            color: item.line_color,
            fillColor: item.fill_color,
            fillOpacity: 0.1,
          }"
          class="custom-polygon">
          <l-tooltip>{{ item.name }}</l-tooltip>
          <LPopup>
            <div ref="anchor" class="base-popup">
              <h4 class="mb-1 popup-content">Название: {{ item.name }}</h4>
              <h4 v-if="item.comment" class="popup-content">Комментарий: {{ item.comment }}</h4>
            </div>
            <div style="text-align: end">
              <v-btn right class="text-none mb-1" outlined color="error" rounded @click="removePolygon(item.id)">
                удалить
              </v-btn>
            </div>
          </LPopup>
        </l-polygon>
      </div>
      <div v-for="item in resComplexPolygons.data" :key="item.id">
        <l-polygon v-if="!polygonStatesshowPopup" :lat-lngs="item.coordinates" :options="polygonOptions" class="custom-polygon">
          <l-tooltip>Жилой комплекс: {{ item.name }}</l-tooltip>
          <LPopup>
            <div ref="anchor" class="base-popup">
              <h4 class="mb-1 popup-content">Название: {{ item.name }}</h4>
            </div>
            <div style="text-align: end">
              <v-btn right class="text-none mb-1" outlined color="primary" rounded :to="`/residential-complexes/${item.id}/view`">
                Подробнее
              </v-btn>
            </div>
          </LPopup>
        </l-polygon>
      </div>
    </l-map>
    <div class="btn-add-polygon" :class="{ 'btn-add-polygon-mobile-active' : isSelectionPoligon, 'is-active-btn-add-polygon' : isActiveFilterType }">
      <v-btn
        v-if="!isAddMarker && showIntercomInfo"
        @click="dialogPolygon = true"
        class="text-none mb-2"
        color="medium-emphasis"
        rounded
        :disabled="selectionEnabled"
      >
        Создать полигон
      </v-btn>
      <v-btn @click="cancelChanges" class="text-none text-success mb-2" rounded color="medium-emphasis" v-if="selectionEnabled">
        Отменить изменения
      </v-btn>
      <v-btn @click="savePolygon" class="text-none mb-2" rounded color="primary" v-if="selectionEnabled">
        Сохранить полигон
      </v-btn>
      <add-polygon
        :dialog="dialogPolygon"
        @toggleSelection="toggleSelection"
        @onColorChange="onColorChange"
        @onFillColorChange="onFillColorChange"
        @close="dialogPolygon = false"
      >
      </add-polygon>
    </div>
    <div class="btn-add-resident-complex">
      <v-btn
        v-if="isAddMarkerResidentComplex"
        @click="dialogResidentComplex = true"
        class="text-none mb-2"
        color="medium-emphasis"
        rounded
        :disabled="selectionEnabledResidentComplex"
      >
        Создать жилой комплекс
      </v-btn>
      <v-btn @click="cancelChangesResidentComplex" class="text-none text-success mb-2" rounded color="medium-emphasis" v-if="selectionEnabledResidentComplex">
        Отменить изменения
      </v-btn>
      <v-btn @click="saveResidentComplex" class="text-none mb-2" rounded color="primary" v-if="selectionEnabledResidentComplex">
        Сохранить
      </v-btn>
      <add-resident-complex
        :dialog="dialogResidentComplex"
        @toggleSelection="toggleSelectionResidentComplex"
        @close="dialogResidentComplex = false"
      />
    </div>
    <div class="btn-add-resident-complex-exit">
      <v-btn
        v-if="isAddMarkerResidentComplex"
        to="/residential-complexes"
        class="text-none mb-2"
        color="error"
        rounded
        :disabled="selectionEnabledResidentComplex"
      >
        Выйти
      </v-btn>
    </div>
    <search-map
      v-if="isSearchMap"
      :is-disabled="isSearchMapDisabled"
      @search="search"
      textPlaceholder="Введите адрес"
      :showIntercomInfo="showIntercomInfo"
      :isComplexMap="true"
      @activeType="activeType"
      @update="updateMap"
    >
    </search-map>
    <div>
      <v-snackbar
        v-model="snackbar"
        bottom
        color="info"
        timeout="4000"
      >
        {{ snackbarText }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { LControlZoom, LMap, LMarker, LPolygon, LPopup, LTileLayer, LTooltip } from 'vue2-leaflet';
import searchMap from '../components/complexesMap/SearchMap';
import markerClusterMap from '../components/complexesMap/MarkerClusterMap';
import addPolygon from '../components/complexesMap/AddPolygon';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import { divIcon } from 'leaflet';
import { mapActions } from 'vuex';
import AddResidentComplex from '@/components/complexesMap/AddResidentComplex';

export default {
  components: {
    AddResidentComplex,
    searchMap,
    LMap,
    LTileLayer,
    LMarker,
    markerClusterMap,
    addPolygon,
    LControlZoom,
    Vue2LeafletMarkerCluster,
    LPolygon,
    LTooltip,
    LPopup,
  },
  data () {
    return {
      resComplexPolygons: [],
      resTerritory: [],
      doorphones: [],
      polygonOptions: {
        color: '#fa6674',
        fillColor: '#262121',
        fillOpacity: 0.1,
        name: '',
        logo: null,
      },
      currentPolygonOptions: {
        name: '',
        comment: '',
        fillOpacity: '0.2',
        color: '',
        fillColor: '',
      },
      snackbar: false,
      snackbarText: '',
      selectionEnabled: false,
      polygonStatesshowPopup: false,
      isSearchMapDisabled: false,
      selectionEnabledResidentComplex: false,
      polygons: [],
      currentPolygon: [],
      isSelectionPoligon: false,
      isSearchMap: true,
      isAddMarker: false,
      isAddMarkerResidentComplex: false,
      dialogResidentComplex: false,
      isAddingPolygon: false,
      colorSelected: false,
      selectedDoorphone: {},
      searchValue: '',
      dialog: false,
      dialogPolygon: false,
      loading: false,
      loadingImageBtn: false,
      isDisplayBtnRC: false,
      isActiveFilterType: false,
      showIntercomInfo: true,
      filterAddress: '',
      filterType: '',
      removedMarker: null,
      zoom: 12,
      previousFilters: {
        address: '',
        type: [],
      },
      center: [54.318607, 48.397819],
      userMarkers: [],
      lastUserMarker: {},
      optionsMarkerCluster: {
        showCoverageOnHover: false,
        removeOutsideVisibleBounds: true,
        singleMarkerMode: false,
        zoomToBoundsOnClick: false,
        maxClusterRadius: 50,
        spiderLegPolylineOptions: {
          color: 'transparent',
        },
        iconCreateFunction: this.customIconCreateFunction,
      },
    };
  },
  async mounted () {
    const showModal = this.$route.query.showModal === 'true';
    if (showModal) {
      this.isAddMarkerResidentComplex = true;
      this.isSelectionPoligon = true;
      this.isAddMarker = true;
      this.isSearchMap = false;
      setTimeout(() => (this.dialogResidentComplex = true), 700);
    } else {
      await this.loadDoorphones();
    }
    this.getResidentialComplex()
      .then((data) => {
        this.resComplexPolygons = data;
      });
    this.loadTerritory();
    window.addEventListener('resize', this.checkScreenWidth);
    this.checkScreenWidth();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  methods: {
    ...mapActions({
      getMapDoorphones: 'Doorphone/getMapDoorphones',
      getTerritory: 'Territory/getTerritory',
      createTerritory: 'Territory/createTerritory',
      deleteTerritory: 'Territory/deleteTerritory',
      updateCoordsDoorphone: 'Doorphone/updateCoordsDoorphone',
      getDevicesCoordinates: 'Doorphone/getDevicesCoordinates',
      updateSnapshot: 'Doorphone/updateSnapshot',
      getResidentialComplex: 'ResidentComplex/getComplex',
      createComplex: 'ResidentComplex/createComplex',
    }),
    checkScreenWidth () {
      const screenWidth = window.innerWidth;
      this.showIntercomInfo = screenWidth >= 800;
    },
    async removePolygon (id) {
      await this.deleteTerritory(id)
        .then(() => {
          this.loadTerritory();
          this.$flash_success('Изменения успешно сохранены!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка, не удолось удалить полигон');
        });
    },
    onColorChange (event) {
      if (event) {
        this.currentPolygonOptions.color = event;
      }
    },
    onFillColorChange (event) {
      if (event) {
        this.currentPolygonOptions.fillColor = event;
      }
    },
    toggleSelectionResidentComplex (name, logo) {
      if (!this.selectionEnabledResidentComplex) {
        if (this.currentPolygon.length > 0) {
          this.polygons.push({
            latlngs: this.currentPolygon,
            options: {
              color: this.polygonOptions.color,
              fillColor: this.polygonOptions.fillColor,
              fillOpacity: this.polygonOptions.fillOpacity,
            },
          });
          this.currentPolygon = [];
        }
      }
      if (logo) {
        this.polygonOptions.logo = logo;
      }
      this.polygonOptions.name = name;
      this.selectionEnabledResidentComplex = !this.selectionEnabledResidentComplex;
      this.dialogResidentComplex = false;
      this.colorSelected = true;
    },
    toggleSelection (name, comment) {
      if (!this.selectionEnabled) {
        if (this.currentPolygon.length > 0) {
          this.polygons.push({
            latlngs: this.currentPolygon,
            options: {
              color: this.currentPolygonOptions.color,
              fillColor: this.currentPolygonOptions.fillColor,
              fillOpacity: this.currentPolygonOptions.fillOpacity,
            },
          });
          this.currentPolygon = [];
        }
      }
      if (comment) {
        this.currentPolygonOptions.comment = comment;
      }
      this.currentPolygonOptions.name = name;
      this.isSearchMapDisabled = true;
      this.selectionEnabled = !this.selectionEnabled;
      this.isSelectionPoligon = true;
      this.dialogPolygon = false;
      this.isAddingPolygon = true;
      this.colorSelected = true;
    },
    cancelChanges () {
      this.currentPolygon = [];
      this.selectionEnabled = !this.selectionEnabled;
      this.isSelectionPoligon = false;
      this.isSearchMapDisabled = false;
      this.colorSelected = false;
      this.$forceUpdate();
    },
    cancelChangesResidentComplex () {
      this.currentPolygon = [];
      this.selectionEnabledResidentComplex = !this.selectionEnabledResidentComplex;
      this.isAddingPolygon = false;
      this.colorSelected = false;
      this.$forceUpdate();
    },
    async savePolygon () {
      if (this.currentPolygon.length > 0) {
        const dataTerritory = {
          area: this.currentPolygon,
          name: this.currentPolygonOptions.name,
          line_color: this.currentPolygonOptions.color,
          fill_color: this.currentPolygonOptions.fillColor,
        };
        if (this.currentPolygonOptions.comment) {
          dataTerritory.comment = this.currentPolygonOptions.comment;
        }
        await this.createTerritory(dataTerritory)
          .then(() => {
            this.loadTerritory();
            this.$flash_success('Изменения успешно сохранены!');
          })
          .catch(() => {
            this.$flash_warning('Ошибка');
          })
          .finally(() => {
            setTimeout(() => {
              this.cancelChanges();
            }, 400);
          });
      }
    },
    onMapClick (event) {
      if (this.selectionEnabled || this.selectionEnabledResidentComplex) {
        this.currentPolygon.push([event.latlng.lat, event.latlng.lng]);
        this.$forceUpdate();
      }
    },
    customIconCreateFunction (cluster) {
      const childCount = cluster._childCount;
      const firingCount = cluster._firingCount;

      let className = 'custom-cluster-icon';
      if (childCount < 10) {
        className += ' custom-cluster-icon-small';
      } else if (childCount < 100) {
        className += ' custom-cluster-icon-medium';
      } else {
        className += ' custom-cluster-icon-large';
      }
      if (firingCount && firingCount === 0) {
        className += ' custom-cluster-icon-none';
      }
      return divIcon({
        html: `<div class='${className}'><span>${childCount}</span></div>`,
        className,
      });
    },
    onClusterClick (a) {
      if (this.$refs.map && this.$refs.map.mapObject) {
        this.$refs.map.mapObject.fitBounds(a.layer.getBounds().pad(0.5));
      }
    },
    loadTerritory () {
      this.getTerritory({
        limit: 9999,
      })
        .then((data) => {
          this.resTerritory = data.data;
        });
    },
    goToListResComplex () {
      this.$router.push({ name: 'ResidentialComplexes' });
    },
    async saveResidentComplex () {
      if (this.currentPolygon.length > 0) {
        const dataTerritory = {
          coordinates: this.currentPolygon,
          name: this.polygonOptions.name,
        };
        await this.createComplex(dataTerritory)
          .then(() => {
            this.getResidentialComplex()
              .then((data) => {
                this.resComplexPolygons = data;
              });
            this.$flash_success('Изменения успешно сохранены!');
            setTimeout(() => this.goToListResComplex(), 1500);
          })
          .catch(() => {
            this.$flash_warning('Ошибка при создании ЖК');
          })
          .finally(() => {
            setTimeout(() => {
              this.cancelChangesResidentComplex();
            }, 400);
          });
      }
    },
    activeType (isActiveFilterType) {
      this.isActiveFilterType = isActiveFilterType;
    },
    search (address, selectedTypes) {
      this.filterAddress = address;
      this.filterType = selectedTypes;
      this.loadDoorphones();
    },
    loadDoorphones () {
      this.snackbarText = 'Загрузка данных карты...';
      this.snackbar = true;
      this.loading = true;
      const filters = {
        address: this.filterAddress,
        type: this.filterType,
      };
      this.getDevicesCoordinates({
        filters: filters,
      })
        .then((res) => {
          this.snackbarText = 'Данные карты успешно загружены';
          this.doorphones = res.data;
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Произошла ошибка загрузки карты');
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.snackbar = false;
          }, 1000);
        });
    },
    updateMap () {
      this.center = [54.318607, 48.397819];
      this.zoom = 12;
    },
  },
  computed: {
    filteredDoorphones () {
      let devices = [];

      if (this.doorphones) {
        const { doorphones = [], barriers = [] } = this.doorphones;
        devices = [...doorphones, ...barriers];
      }

      return devices;
    },
  },
};
</script>

<style lang="scss">
@import '../components/complexesMap/TheMap.scss';
.map {
  width: -webkit-fill-available;
  position: fixed;
  height: 100%;
}
.base-popup {
  width: 300px;
}
.btn-add-marker {
  position: absolute;
  display: grid;
  top: 10px;
  right: 20%;
  z-index: 10;
}

.popup-content {
  word-wrap: break-word;
}
.btn-add-polygon {
  position: absolute;
  display: grid;
  top: 10px;
  right: 22%;
  z-index: 10;
}
.btn-add-resident-complex {
  position: absolute;
  display: grid;
  top: 10px;
  right: 10%;
}
.btn-add-resident-complex-exit {
  position: absolute;
  display: grid;
  top: 10px;
  right: 4%;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
@media screen and (max-width: 1550px) {
  .btn-add-marker {
    top: 225px;
    right: 3%;
    z-index: 0;
  }
  .is-active-btn-add-marker {
    top: 405px
  }
  .btn-add-polygon {
    top: 270px;
    right: 3%;
    z-index: 0;
  }
  .is-active-btn-add-polygon {
    top: 450px
  }
  .btn-add-resident-complex {
    top: 60px;
    right: 1%;
  }
  .btn-add-polygon-mobile-active {
    top: 140px;
    right: 5%;
  }
}

@media screen and (max-width: 400px) {
  .btn-add-polygon {
    right: 11%;
  }
}
</style>
